export const DEFAULT = 'default';
export const UPDATE_PENDING_CREATED = 'update-pending-created';
